import React from 'react'

interface GidIaIconProps {
  size?: number
  className?: string
  style?: React.CSSProperties
}

/**
 * Ícone Vetorial Único da GID IA — combina a identidade oficial do GID
 * (Azul Marinho #001842, anel Verde-Lima #A6C10B e monograma GID) com o pulso
 * neural e estrela de Inteligência Artificial (IA).
 */
export const GidIaIcon: React.FC<GidIaIconProps> = ({ size = 22, className, style }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
    >
      <circle cx="60" cy="60" r="56" fill="#001842" />
      <circle cx="60" cy="60" r="55" stroke="#A6C10B" strokeWidth="6.5" />
      <path
        d="M 18 60 A 42 42 0 0 1 102 60"
        stroke="#38BDF8"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeDasharray="4 5"
        opacity="0.75"
      />
      <path
        d="M 90 18 C 90 24.5 93 27.5 99.5 27.5 C 93 27.5 90 30.5 90 37 C 90 30.5 87 27.5 80.5 27.5 C 87 27.5 90 24.5 90 18 Z"
        fill="#C6E419"
      />
      <path
        d="M 28 24 C 28 27.2 29.8 29 33 29 C 29.8 29 28 30.8 28 34 C 28 30.8 26.2 29 23 29 C 26.2 29 28 27.2 28 24 Z"
        fill="#38BDF8"
      />
      <text
        x="60"
        y="63"
        textAnchor="middle"
        fill="#FFFFFF"
        fontFamily="'Montserrat', 'Inter', 'Segoe UI', Arial, sans-serif"
        fontWeight="900"
        fontSize="35"
        letterSpacing="1"
      >
        GID
      </text>
      <rect
        x="34"
        y="73"
        width="52"
        height="22"
        rx="11"
        fill="#A6C10B"
        stroke="#001842"
        strokeWidth="1.5"
      />
      <text
        x="60"
        y="88.5"
        textAnchor="middle"
        fill="#001842"
        fontFamily="'Montserrat', 'Inter', 'Segoe UI', Arial, sans-serif"
        fontWeight="900"
        fontSize="13.5"
        letterSpacing="1.5"
      >
        ✦ IA
      </text>
    </svg>
  )
}

export default GidIaIcon

